import React, { useEffect, useState } from "react";
import { RecapPayload } from "../../services/reportsRecapGet";
import RecapStory from "./RecapStory";
import {
    ClosingSlide,
    HeroSlide,
    LoginStatsSlide,
    PeakScoreSlide,
    PersonalitySlide,
    ScoreEvolutionSlide
} from "./slides";

interface RecapModalProps {
    data: RecapPayload | null;
    isOpen: boolean;
    onClose: () => void;
}

const RecapModal: React.FC<RecapModalProps> = ({ data, isOpen, onClose }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const totalSlides = 6;

    useEffect(() => {
        if (isOpen) {
            setCurrentSlide(0);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    if (!isOpen || !data) return null;

    const handleNext = () => {
        if (currentSlide < totalSlides - 1) {
            setCurrentSlide(curr => curr + 1);
        } else {
            onClose();
        }
    };

    const handlePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide(curr => curr - 1);
        }
    };

    const renderSlide = () => {
        switch (currentSlide) {
            case 0:
                return <HeroSlide />;
            case 1:
                return <PersonalitySlide scoreHistory={data.scoreHistory} />;
            case 2:
                return <LoginStatsSlide
                    loginCount={data.loginCount}
                    hasScoreHistory={!!(data.scoreHistory && data.scoreHistory.puntajes && data.scoreHistory.puntajes.length > 0)}
                />;
            case 3:
                return <ScoreEvolutionSlide history={data.scoreHistory ? data.scoreHistory.puntajes : []} />;
            case 4:
                return <PeakScoreSlide history={data.scoreHistory ? data.scoreHistory.puntajes : []} />;
            case 5:
                return (
                    <ClosingSlide
                        onRestart={() => setCurrentSlide(0)}
                        onClose={onClose}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <RecapStory
            currentSlide={currentSlide}
            totalSlides={totalSlides}
            onNext={handleNext}
            onPrev={handlePrev}
            onClose={onClose}
        >
            {renderSlide()}
        </RecapStory>
    );
};

export default RecapModal;
